import styled from '@emotion/styled';

import Link from '~/common/components/Link';
import { useUser } from '~/common/hooks/useAuthentication';
import useBoltStatus from '~/common/hooks/useBoltStatus';
import BailOutModal from '~/modals/BailOutModal';
import { useModalState } from '~/modals/modalStore';
import lang from '~/pages/Home/language.json';
import { useNavigation } from '~/stores/navigationStore';

const BailOutContainer = styled.div<any>`
  display: flex;
  justify-content: flex-end;
  @media (min-width: 1024px) and (max-width: 1440px) {
    width: 94%;
    margin: auto 3%;
  }
`;

const StyledBailOutLink = styled<any>(Link)`
  margin-top: 32px;
  margin-bottom: 64px;
  color: ${(props) => props.theme.colors?.blue[600]};
  font-size: ${(props) => props.theme.functions?.pixelsToRem(14)};
  line-height: ${(props) => props.theme.functions?.pixelsToRem(24)};
  border-bottom: 1px solid ${(props) => props.theme.colors?.blue[600]};
  opacity: ${(props) => (props.disabled ? 0.5 : 'none')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    text-decoration: none;
    font-weight: 500;
  }
`;

export const BailOut = () => {
  const { selectedCategory } = useNavigation();
  const { isUnderwriter, role } = useUser();
  const {
    data: { isLoanSubmitted },
  } = useBoltStatus();
  const { onOpen: openBailOut } = useModalState('bailout');

  const isCategoryReadOnlyPermission = selectedCategory?.isReadOnlyPermission;

  const isBailOutLinkDisabled =
    isLoanSubmitted ||
    role.includes('AccountExecutive') ||
    isCategoryReadOnlyPermission;
  const handleBailOut = () => !isBailOutLinkDisabled && openBailOut();

  return (
    <BailOutContainer>
      {!isUnderwriter && (
        <>
          <StyledBailOutLink
            as="button"
            type="button"
            onClick={() => handleBailOut()}
            disabled={isBailOutLinkDisabled}
            aria-disabled={isBailOutLinkDisabled}
          >
            {lang.BAIL_OUT_LINK}
          </StyledBailOutLink>
          <BailOutModal />
        </>
      )}
    </BailOutContainer>
  );
};
